module.exports = __webpack_public_path__ + "media/images/admin/icons/map-65b9ab83cf598b2123b05a10be997d31.svg";